<script setup>
import Logos from "@/components/template/Logos.vue";
import { useUserStore } from "@/stores/user"; // Asegúrate de ajustar la ruta según tu estructura
const store = useUserStore();

function Logout() {
  store.logout();
}
</script>

<template>
  <nav class="navbar fixed-top navbar-light bg-light">
    <div
      class="container-fluid nav-container"
      style=""
    >
      <div class="divide-block d-flex flex-row">
        <div class="logo d-flex flex-row">
          <div>
            <img
              src="../../assets/logounocomaseiscontacts.png"
              alt=""
              class="img-fluid"
              style="width: 180px"
            />
          </div>

          <!-- <div class="logos-page ml-5 d-none d-md-block">
            <Logos />
          </div> -->
        </div>

        <div
          class="user-information d-flex flex-row"
          v-if="store.user"
        >
          <div class="container-information-user">
            <div class="user-name d-none d-md-block">{{ store.user.name }}</div>
            <div class="user-type">
              {{
                store.user.type == "admin"
                  ? "Administrador"
                  : store.user.type == "manager"
                  ? "Editor"
                  : "Observador"
              }}
            </div>
          </div>
          <div class="dropdown">
            <div
              class="avatar-dashboard d-flex"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fa-sharp fa-light fa-bars"></i>

              <ul
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton"
              >
                <li>
                  <a
                    style="font-size: 14px; font-weight: 500"
                    class="dropdown-item"
                    href="#"
                    @click.prevent="Logout()"
                    >Cerrar sesión</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<style lang="scss" scoped>

@media(min-width: 768px) {
  .nav-container {
    padding-inline: 35px
  }
  
}

@media(max-width: 768px) {
  .nav-container {
    padding-inline: 0;
  }
  
}




.user-information {
  .dropdown-item.active,
  .dropdown-item:active {
    color: #fff;
    text-decoration: none;
    background-color: #ffffff;
  }

  text-align: right;
  float: right;
  justify-content: end;
  text-align: right;
  align-items: center;

  .avatar-dashboard {
    background: #ffffff;
    cursor: pointer;
    height: 35px;
    width: 35px;
    text-align: center;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
  }

  .container-information-user {
    padding-right: 10px;
  }

  .user-name {
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;
  }

  .user-type {
    font-size: 9px;
    text-transform: uppercase;
    font-weight: 500;
    color: #818181;
  }
}
.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  height: 55px;
}

.divide-block {
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
</style>
